var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailOpenL(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.75232 5.57143L9.05123 12.2999M9.05123 12.2999L2.75232 20.4286M9.05123 12.2999L10.4838 13.8301C11.3376 14.6497 12.6626 14.6497 13.5163 13.8301L15.0222 12.2999M21.4444 5.77382L15.0222 12.2999M15.0222 12.2999L21.4444 20.2262M2.75232 20.4286C3.14406 20.7842 3.65864 21 4.22222 21H19.7778C20.4414 21 21.0372 20.7007 21.4444 20.2262M2.75232 20.4286C2.29098 20.0097 2 19.3969 2 18.7143V7.28571C2 6.02335 2.99492 5 4.22222 5H19.7778C21.0051 5 22 6.02335 22 7.28571V18.7143C22 19.2939 21.7902 19.8232 21.4444 20.2262",
    stroke: "#3E3092",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailOpenL);
export default __webpack_public_path__ + "static/media/mailOpenL.8d091814cc05f6764aeda948d0506873.svg";
export { ForwardRef as ReactComponent };